// extracted by mini-css-extract-plugin
export var resizer = "_df-0";